import { useCallback, useEffect, useState } from "react";

/** UI wait before the user can ask Clerk for another OTP. Not Clerk's 10-min TTL. */
export const OTP_RESEND_COOLDOWN_SEC = 30;

export const startResendRemaining = (
  seconds = OTP_RESEND_COOLDOWN_SEC,
): number => seconds;

export const tickResendRemaining = (remaining: number): number =>
  Math.max(0, remaining - 1);

export const resetResendRemaining = (): number => 0;

export const canResendOtp = (remaining: number): boolean => remaining <= 0;

/** `00:30` clock for the cooldown copy. */
export const formatResendClock = (remaining: number): string => {
  const total = Math.max(0, Math.floor(remaining));
  const minutes = Math.floor(total / 60);
  const seconds = total % 60;
  return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
};

export function useOtpResendCooldown() {
  const [remaining, setRemaining] = useState(0);

  useEffect(() => {
    if (remaining <= 0) return;
    const id = window.setTimeout(() => {
      setRemaining((current) => tickResendRemaining(current));
    }, 1000);
    return () => window.clearTimeout(id);
  }, [remaining]);

  const start = useCallback(() => {
    setRemaining(startResendRemaining());
  }, []);

  const reset = useCallback(() => {
    setRemaining(resetResendRemaining());
  }, []);

  return {
    remaining,
    canResend: canResendOtp(remaining),
    start,
    reset,
  };
}
